import {
  trackProductError,
  trackProductEvent,
  type ProductBaseProperties,
} from "./product";

export const ACTIVITIES_FLOW = "activities";

export type ActivitiesEventName =
  | "activity_create_clicked"
  | "activity_filter_changed"
  | "activity_create_submit_attempt"
  | "activity_created"
  | "activity_create_error"
  | "activity_update_submit_attempt"
  | "activity_updated"
  | "activity_update_error"
  | "activity_status_changed"
  | "activity_status_change_error"
  | "activity_participation_updated"
  | "activity_participation_update_error"
  | "activity_model_use_clicked"
  | "activity_model_create_submit_attempt"
  | "activity_model_created"
  | "activity_model_create_error"
  | "activity_checkin_submit_attempt"
  | "activity_checkin_success"
  | "activity_checkin_error"
  | "activity_form_chat_started"
  | "activity_form_chat_field_collected"
  | "activity_form_chat_completed"
  | "activity_form_chat_submitted"
  | "activity_form_chat_submit_error";

export const trackActivitiesEvent = (
  event: ActivitiesEventName,
  baseProperties: ProductBaseProperties,
  eventProperties?: Record<string, unknown>,
): void => {
  trackProductEvent(event, baseProperties, eventProperties, ACTIVITIES_FLOW);
};

export const trackActivitiesError = (
  event: ActivitiesEventName,
  baseProperties: Omit<ProductBaseProperties, "success" | "errorCode">,
  error: unknown,
  eventProperties?: Record<string, unknown>,
): void => {
  trackProductError(
    event,
    baseProperties,
    error,
    eventProperties,
    ACTIVITIES_FLOW,
  );
};
